'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.propTypes = undefined;

var _objectDestructuringEmpty2 = require('babel-runtime/helpers/objectDestructuringEmpty');

var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);

exports.prepare = prepare;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
    backgroundColor: _propTypes2.default.string,
    borderColor: _propTypes2.default.string,
    activeColor: _propTypes2.default.string,
    type: _propTypes2.default.string,
    checked: _propTypes2.default.bool
};

function prepare(_ref) {
    (0, _objectDestructuringEmpty3.default)(_ref);


    return {};
}